import { get } from 'lodash-es';

import { emptyArray } from 'ui-components/default-props/empty';

export const selectIsLoading = (state) => get(state, 'isLoading');
export const selectFulfillmentPlanIds = (state) => get(state, 'fulfillmentPlanIds', emptyArray);
